import React, { useState } from "react";
import { logo, background } from "../../assets";
import axios from "../../library/axios";
import { MySwal } from "../../library/swal";
import { IconLogin } from "@tabler/icons-react";
import { setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");

  const handleLogin = () => {
    setLoading(true);
    setDisabled(true);
    const requestBody = {
      username: username,
      password: password,
    };

    axios({
      url: "/users/auth",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Berhasil Login!",
            text: `Akun kamu sudah terverifikasi, Mohon tunggu.`,
          });

          setTimeout(() => {
            // get token from the result
            localStorage.setItem(`token${getSlug() ? '-' + getSlug() : ''}`, res?.data?.token);
            
            // Determine redirect path based on user role
            const groupName = res?.data?.groupName || "";
            let redirectPath = "/profile"; // default redirect
            
            if (groupName === "Kelompok Kerja") {
              redirectPath = "/dashboard-pokja";
            } else if (groupName === "Surveior Internal") {
              redirectPath = "/dashboard-internal";
            } else if (groupName === "Surveior External") {
              redirectPath = "/accreditation";
            }
            
            setHrefWithSlugHook(redirectPath);
          }, 3000);

          setLoading(false);
          setDisabled(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <>
      <div className="container-fluid vh-100">
        <div className="row h-100">
          <div className="col-md-6 d-flex align-items-center justify-content-center">
            {/*begin::Wrapper*/}
            <div className="d-flex flex-column position-xl-fixed top-2 bottom-2 w-xl-600px">
              {/*begin::Content*/}
              <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
                {/*begin::Logo*/}
                <img
                  alt="Logo"
                  src={logo}
                  className="img-fluid mb-10 mx-auto" // tambahkan mx-auto
                  style={{
                    width: '400px',
                    height: 'auto',
                  }}
                />
                {/*end::Logo*/}
                {/*begin::Title*/}
                <h1
                  className="fw-bolder fs-3qx pb-5 pb-md-4"
                  style={{ color: '#26196b' }}
                >
                  S P E A K
                </h1>
                {/*end::Title*/}
                {/*begin::Description*/}
                <p className="fw-bold fs-2" style={{ color: '#26196b' }}>
                  Selamat Datang di <br /> Aplikasi SPEAK RUMAH SAKIT <br />
                  (Sistim Pengelolaan Akreditasi LAM-KPRS)
                </p>
                {/* <p>
                  Sistim ini digunakan untuk mengelola semua Data Akreditasi
                  Rumah Sakit dan Surveior yang dilakukan oleh LAM-KPRS.{' '}
                </p> */}
                {/*end::Description*/}
              </div>
              {/*end::Content*/}

              {/*end::Illustration*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Aside*/}

          {/* Bagian kanan - Form Login */}
          <div
            className="col-md-6 d-flex align-items-center justify-content-center"
            style={{
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              minHeight: '100vh', // supaya penuh layar
            }}
          >
            <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
              {/*begin::Heading*/}
              <div className="text-center mb-5">
                {/*begin::Title*/}
                <h1
                  className="fw-bolder fs-2qx pb-2 pb-md-2"
                  style={{ color: '#26196b' }}
                >
                  LOGIN
                </h1>

                {/* <h5 className="mb-3">
                  <i style={{ color: '#26196b' }}>Versi</i>
                </h5>
                <h1 className="mb-3" style={{ color: '#26196b' }}>
                  RUMAH SAKIT
                </h1> */}
                {/*end::Title*/}
              </div>
              {/*begin::Heading*/}
              {/*begin::Input group*/}
              <div className="fv-row mb-5">
                {/*begin::Label*/}
                <label className="form-label fs-6 fw-bolder text-dark">
                  Username
                </label>
                {/*end::Label*/}
                {/*begin::Input*/}
                <input
                  className="form-control form-control-lg form-control-solid"
                  type="text"
                  name="email"
                  autoComplete="off"
                  onChange={(e) => setusername(e.target.value)}
                  value={username}
                />
                {/*end::Input*/}
              </div>
              {/*end::Input group*/}
              {/*begin::Input group*/}
              <div className="fv-row mb-5">
                {/*begin::Wrapper*/}
                <div className="d-flex flex-stack mb-2">
                  {/*begin::Label*/}
                  <label className="form-label fw-bolder text-dark fs-6 mb-0">
                    Password
                  </label>
                  {/*end::Label*/}
                </div>
                {/*end::Wrapper*/}
                {/*begin::Input*/}
                <input
                  className="form-control form-control-lg form-control-solid"
                  type="password"
                  name="password"
                  autoComplete="off"
                  onChange={(e) => setpassword(e.target.value)}
                  value={password}
                />
                {/*end::Input*/}
              </div>
              {/*end::Input group*/}
              {/*begin::Actions*/}
              <div className="text-center">
                {/*begin::Submit button*/}
                <button
                  onClick={() => handleLogin()}
                  type="button"
                  id="kt_sign_in_submit"
                  className="btn btn-sm btn-primary w-100 mb-3"
                  disabled={disabled}
                >
                  <IconLogin stroke={2} />
                  &nbsp;
                  {loading === true ? 'Mohon Tunggu..' : 'Login'}
                </button>
                {/*end::Submit button*/}
                <small className="align-items-center">
                  APP Version: 0.4.64
                </small>
              </div>
              {/*end::Actions*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
